import React from "react";

export default function Layout({ children }) {
  return <main className="pt-[74px] min-h-screen">{children}</main>;
}
